import { useState, useEffect } from "react";

import { useContextValue } from "../../context/context";
import { Card } from "../Card/Card";

import { popUps } from "../PopUps";
import { cardImages } from "../../assets/cardIcons";
import "./style.css";

const cardColors = ["#27999A", "#A23A39", "#D66641", "#10849D", "#5A9B59", "#925B92"]
const cardText = ["Sprache", "Einsatzort", "Entfernung", "Stundensatz", "Geshlecht", "Qualifikation"]

const cardsData = cardImages.map((img, i) => {
	return {
		icon: img,
		text: cardText[i],
		backgroundColor: cardColors[i],
	}
})

export const Cards = () => {
	const [activePopUp, setActivePopUp] = useState(null);
	const { filledCards } = useContextValue();

	const closePopUp = () => {
		setActivePopUp(null);
	};

	// Prevent body scrolling when modal is open
	useEffect(() => {
		if (activePopUp) {
			document.body.classList.add('modal-open');
		} else {
			document.body.classList.remove('modal-open');
		}

		// Cleanup on unmount
		return () => {
			document.body.classList.remove('modal-open');
		};
	}, [activePopUp]);

	const filterCardsByFilledCards = (cardsData, filledCards) => {
		return cardsData.filter(
			(card) => !filledCards.some((filledCard) => filledCard.title === card.text)
		);
	};
	
	const filteredCardText = filterCardsByFilledCards(cardsData, filledCards);

	if (filteredCardText.length === 0) {
		return null;
	}

	const cardItems = filteredCardText.map((card, i) => {
		return (
			<Card
				key={card.text}
				img={card.icon}
				text={card.text}
				backgroundColor={card.backgroundColor}
				onClick={() => setActivePopUp(card.text)}
			/>
		)
	})

	const activePopUpData = popUps.find((popUp) => popUp.key === activePopUp);
	const ActivePopUpComponent = activePopUpData?.component;

	return (
		<div className="cards">
			{cardItems}
			{ActivePopUpComponent && (
				<div className="pop-up-overlay" onClick={closePopUp}>
					<div className="pop-up-content" onClick={(e) => e.stopPropagation()}>
						<ActivePopUpComponent onClose={closePopUp} />
					</div>
				</div>
			)}
		</div>
	)
}
